/**
 * Atheron — "You may also like" in the cart drawer.
 * "+ Add" puts the product in the cart and refreshes the drawer the same way
 * the theme's own add-to-cart does (Shopify cart event + section HTML).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!customElements.get('atheron-cart-upsell')) {
  customElements.define(
    'atheron-cart-upsell',
    class AtheronCartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = async (event) => {
        const button = event.target.closest('[data-atheron-add]');
        if (!button || button.disabled) return;
        event.preventDefault();

        const item = button.closest('.atheron-upsell__item');
        const select = item?.querySelector('[data-atheron-variant]');
        const variantId = select?.value || button.dataset.variantId;
        if (!variantId) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(variantId), quantity: 1 }],
            promise: deferred.promise,
          })
        );

        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const addResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
            }),
          });
          const added = await addResponse.json();
          if (added.status) throw new Error(added.description || added.message || 'Could not add to cart');

          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
          const ajaxCart = await cartResponse.json();

          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
            detail: {
              items: ajaxCart.items,
              source: 'atheron-cart-upsell',
              sourceId: 'atheron-cart-upsell',
              itemCount: 1,
              sections: added.sections,
              didError: false,
            },
          });
        } catch (error) {
          deferred.reject(error);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.textContent = 'Try again';
        }
      };
    }
  );
}
